import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'CP',
};

type CPAuditHistoryMessageHistoryLoc =
	| 'CPAuditHistoryMessageHistoryTitle'
	| 'CPAuditHistoryMessageHistoryNoMessages';

export const cpAuditHistoryMessageHistoryLocs: LocDefs<CPAuditHistoryMessageHistoryLoc> = {
	CPAuditHistoryMessageHistoryTitle: {
		defaultValue: 'Message History',
		description: 'Section title for the audit history message history section.',
		displayPath: `History|Audit|Details|Message History|Section Title`,
		displayType: 'Title',
		...sharedProps,
	},
	CPAuditHistoryMessageHistoryNoMessages: {
		defaultValue: 'No messages found',
		description: 'Message to display when no messages are found.',
		displayPath: `History|Audit|Details|Message History|No Messages`,
		displayType: 'Content',
		...sharedProps,
	},
};

export const cpAuditHistoryMessageHistoryLocKeys = MapLocKeys<CPAuditHistoryMessageHistoryLoc>(
	cpAuditHistoryMessageHistoryLocs
);
export type CPAuditHistoryMessageHistoryLocKeys = typeof cpAuditHistoryMessageHistoryLocKeys;
